<template>
  <div>
    <HomeHeader :entryList="entryList" :isScroll="true" />
    <div class="quilt-card">
      <div class="quilt-card-container">
        <div ref="videoBox" class="video-box">
          <video
            ref="video"
            src="https://cdnimg-v2.gamekee.com/wiki2.0/video/50118/418239/2025/2/14/99408.mp4"
            height="480"
            preload="auto"
            muted
            playsinline
          ></video>
          <!-- 遮挡5星视频右上角的icon -->
          <div class="mask"></div>
        </div>
        <div class="card-box">
          <template v-if="actionVisible">
            <div class="back" @click="handleBack"></div>
            <div class="header">
              <AssetCount :assetCount="assetCount" />
            </div>
            <video
              class="bg-video"
              src="https://cdnimg-v2.gamekee.com/wiki2.0/video/50118/418239/2025/2/18/429777.mp4"
              autoplay
              loop
              muted
              playsinline
            ></video>
            <div class="footer">
              <div v-if="shareBtnVisible" ref="shareBtn" class="share-btn" @click="handleShare">
                分享至社区
              </div>
              <!-- <el-tooltip
              :manual="true"
              :value="tooltipVisible"
              :visible-arrow="false"
              :offset="10"
              :popper-class="singlePopperClass"
              placement="top"
            >
              <div class="quilt-btn" @click="handleStartQuilt(1)">
                <span>抽1次</span>
                <div class="price">1</div>
              </div>
              <template slot="content">
                <div class="single-tip">
                  <img class="icon" src="@/assets/zs_imgs/ck-star.png" />
                  <span class="txt">{{ singleTipTxt }}</span>
                </div>
              </template>
            </el-tooltip> -->
              <el-tooltip
                :manual="true"
                :value="tooltipVisible"
                :visible-arrow="true"
                :popper-class="mutilPopperClass"
                placement="top"
              >
                <div class="quilt-btn" @click="handleStartQuilt(10)">
                  <span>抽10次</span>
                  <div class="price">10</div>
                </div>
                <template slot="content">
                  <div class="mutil-tip">
                    <img class="icon" src="@/assets/zs_imgs/ck-star.png" />
                    <span class="txt">{{ mutilTipTxt }}</span>
                  </div>
                </template>
              </el-tooltip>
            </div>
          </template>
          <component
            ref="compInstance"
            :is="currComp"
            :navList="navList"
            :cardResult="cardResult"
            :maxNum="maxNum"
            :currentNav="currentNav"
            :assetCount="assetCount"
            @currentNavChange="onCurrentNavChange"
            @record="onRecordView"
            @animationEnd="onAnimationEnd"
          ></component>
        </div>
        <div class="comment-box">
          <CommentLikeComponent :type="type" :hideBack="true" />
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="shareDialogVisible" title="抽卡结果分享" width="618px" top="30vh" append-to-body>
      <SharePanel :shareBase64="shareBase64" @shareSubmit="onSharePanelSubmit" />
    </el-dialog>
  </div>
</template>
<script>
import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";
import "tippy.js/themes/light.css";

import mergeAsyncDataMixin from "@/mixins/mergeAsyncDataMixin";
import { handleModelList } from "../../utils";
import { apiCardPoolQueryGachaList, apiCardPoolGachaCard } from "@/api/wiki-zsca";
import { apiContentEdit } from "@/api/contentApi.js";

import CardBanner from "./components/CardBanner.vue";
import MutilResult from "./components/MutilResult.vue";
import SingleResult from "./components/SingleResult.vue";
import RecordView from "./components/RecordView.vue";
import MutilAnimation from "./components/MutilAnimation.vue";
import AssetCount from "./components/AssetCount.vue";
import SharePanel from "./components/SharePanel.vue";
import HomeHeader from "../components/homeHeader.vue";
import CommentLikeComponent from "../components/commentLikeComponent.vue";

export default {
  name: "QuiltCard",
  mixins: [mergeAsyncDataMixin],
  components: {
    SharePanel,
    HomeHeader,
    AssetCount,
    CommentLikeComponent,
    [CardBanner.name]: CardBanner,
    [MutilResult.name]: MutilResult,
    [SingleResult.name]: SingleResult,
    [RecordView.name]: RecordView,
    [MutilAnimation.name]: MutilAnimation
  },
  data() {
    return {
      isSSRGetData: false,
      type: 7, // 卡池类型
      tooltipVisible: true,
      actionVisible: false,
      shareBtnVisible: false,
      shareDialogVisible: false,
      assetCount: 50000,
      entryList: [],
      currComp: "CardBanner",
      navList: [],
      currentNav: {},
      /** 抽卡结果 */
      cardResult: {},
      maxNum: 0,
      shareBase64: "",
      /** “分享至社区”tippy */
      shareTippyInstance: null,
      /** 是否处于抽卡过程中，即从点击抽卡到下一次抽卡就绪 */
      isCompleted: true
    };
  },
  async asyncData({ store, router, ssrContext, $apis }) {
    try {
      console.log("asyncData start");
      // TDK设置
      const gameInfo = store.getters.gameInfo;
      if (gameInfo.is_tdk && gameInfo.Config) {
        ssrContext.title = gameInfo.Config.seo_title;
        ssrContext.keywords = gameInfo.Config.seo_keywords;
        ssrContext.description = gameInfo.Config.seo_desc;
      } else {
        ssrContext.title = `${gameInfo.name}wiki官网_${gameInfo.name}图鉴|GameKee`;
        ssrContext.keywords = `${gameInfo.name}wiki,${gameInfo.name}官网,${gameInfo.name},${gameInfo.name}人物图鉴,${gameInfo.name}装备图鉴`;
        ssrContext.description = `${gameInfo.name}wiki官网为您带来${gameInfo.name}从新手到高手的一切攻略内容，这是由大神玩家们制作的${gameInfo.name}专属资料库，包含实时更新的${gameInfo.name}人物图鉴和${gameInfo.name}装备图鉴。`;
      }
      // 数据预取
      let pagination = {
        limit: 20,
        page_no: 1,
        page_total: 1,
        total: 0
      };

      const params = {
        type: "4,17",
        order_by: "created_at",
        ...pagination
      };
      const res = await Promise.all([
        $apis.apiWikiIndexV2(),
        $apis.apiContentTopList(params),
        $apis.apiWikiEntry(),
        $apis.apiWikiEntryLastUpdateList(),
        $apis.apiCardPoolQueryGachaList({ serverId: router.currentRoute.params.id })
      ]);

      const { code: wikiResCode, data: wikiData } = res[0];

      let modelsList = handleModelList();
      if (wikiResCode == 0) {
        modelsList = handleModelList(wikiData);
      }
      const { code: qzResCode, data: qzData, meta: qzMeta } = res[1];
      let qzList = [];
      if (qzResCode == 0) {
        qzList = qzData;
        pagination = qzMeta.pagination;
      }
      const { code: entryResCode, data: entryResData } = res[2];
      let entryList = [];
      if (entryResCode == 0) {
        entryList = entryResData.entry_list;
      }

      const { code: lastUpdateResCode, data: lastUpdateResData } = res[3];
      let lastUpdateList = [];
      if (lastUpdateResCode == 0) {
        lastUpdateList = lastUpdateResData;
      }

      console.log("asyncData end");
      return {
        modelsList,
        qzList,
        pagination,
        entryList,
        lastUpdateList,
        navList: res[4].data,
        currentNav: res[4].data[0],
        maxNum: res[4].data[0].max_num,
        actionVisible: true,
        isSSRGetData: true
      };
    } catch (err) {
      console.log(err);
    }
  },
  computed: {
    mutilTipTxt() {
      return this.maxNum >= 90 ? "5★以上必得" : "4★以上必得";
    },
    mutilPopperClass() {
      return this.maxNum >= 90
        ? "__ck-mutil-tip-class__ __ck-mutil-tip-star5-class__"
        : "__ck-mutil-tip-class__ __ck-mutil-tip-star4-class__";
    },
    singleTipTxt() {
      return this.maxNum >= 99 ? "5★以上必得" : "";
    },
    singlePopperClass() {
      return this.maxNum >= 99 ? "__ck-mutil-tip-class__ __ck-mutil-tip-star4-class__" : "__ck-single-tip-hide-class__";
    }
  },
  beforeMount() {
    if (!this.isSSRGetData) {
      this.fetchNavList();
    }
  },
  mounted() {
    this.fetchSessionShareParams();
  },
  beforeDestroy() {
    if (this.shareTippyInstance) {
      this.shareTippyInstance.destroy();
    }
  },
  methods: {
    async fetchNavList() {
      const { code, data } = await apiCardPoolQueryGachaList({ serverId: this.$route.params.id });
      if (code === 0) {
        this.navList = data;
        this.currentNav = data[0];
        this.maxNum = data[0].max_num;
        this.actionVisible = true;
      }
    },
    async handleStartQuilt(count) {
      if (!this.isCompleted) return;
      this.isCompleted = false;
      const { code, data } = await apiCardPoolGachaCard({ num: count, id: this.currentNav.id });
      if (code === 0) {
        this.cardResult = [];
        await this.$nextTick();
        /** 抽出5星播放动画 */
        const hasStar5 = data.result.some(({ star }) => parseInt(star) === 5);
        if (hasStar5) {
          this.tooltipVisible = false;
          await new Promise(resolve => {
            /** @type {HTMLVideoElement} */
            const video = this.$refs.video;
            video.addEventListener(
              "ended",
              () => {
                this.$refs.videoBox.style.zIndex = -1;
                resolve();
              },
              { once: true }
            );
            video.addEventListener(
              "click",
              () => {
                video.currentTime = video.duration;
              },
              { once: true }
            );
            this.$refs.videoBox.style.zIndex = 5;
            video.play();
          });
        }
        this.shareBtnVisible = true;
        this.playAudio("midAudio");
        this.cardResult = data.result;
        this.maxNum = data.max_num;
        const nav = this.navList.find(el => el.id === this.currentNav.id);
        if (nav) {
          nav.max_num = data.max_num;
        }
        if (count === 1) {
          this.currComp = SingleResult;
          this.assetCount -= 1;
        }
        if (count === 10) {
          this.currComp = MutilAnimation;
          this.actionVisible = false;
          // this.currComp = MutilResult;
          this.assetCount -= 10;
        }
      }
    },
    handleBack() {
      if (this.currComp === "CardBanner") {
        this.$router.go(-1);
      } else {
        this.currComp = "CardBanner";
        this.tooltipVisible = true;
        this.shareBtnVisible = false;
      }
    },
    async handleShare() {
      let base64 = "";
      try {
        base64 = await this.$refs.compInstance.exposeGenerateCanvas();
      } catch (error) {
        console.log("html2canvas error:", error.message);
      }
      if (!base64) return;
      this.shareBase64 = base64;
      this.shareDialogVisible = true;
    },
    onCurrentNavChange(nav) {
      this.currentNav = nav;
      this.maxNum = nav.max_num;
    },
    onRecordView() {
      this.tooltipVisible = false;
      this.currComp = "RecordView";
    },
    async onAnimationEnd() {
      this.currComp = MutilResult;
      this.playAudio("endAudio");
      this.actionVisible = true;
      this.tooltipVisible = true;
      this.isCompleted = true;
    },
    /**
     * 播放音频
     * @param {"midAudio" | "endAudio"} value - "midAudio" | "endAudio"
     */
    playAudio(value) {
      const audioSource = {
        midAudio: "https://cdnimg-v2.gamekee.com/wiki2.0/images/w_0/h_0/50118/418239/2025/2/25/761204.MP3",
        endAudio: "https://cdnimg-v2.gamekee.com/wiki2.0/images/w_0/h_0/50118/418239/2025/2/25/418547.MP3"
      };
      new Audio(audioSource[value]).play();
    },
    async onSharePanelSubmit(form) {
      const params = Object.assign({}, form, {
        tag: "8",
        type: 4,
        editor_type: 1,
        content: "",
        content_type: 0,
        is_image_text: 1,
        content_json: JSON.stringify([
          {
            type: "paragraph",
            children: [
              {
                text: form.summary
              },
              {
                type: "image",
                key: "soxjn8LIJFJC7FUj" + Date.now(),
                src: form.thumb,
                alt: "",
                isAdaptive: true,
                style: {
                  width: "216px",
                  height: "120px"
                },
                children: [
                  {
                    text: ""
                  }
                ]
              },
              {
                text: ""
              }
            ]
          }
        ])
      });

      if (!this.isLoginShow("")) {
        sessionStorage.setItem("loginAfterShareParams", JSON.stringify(params));
        return;
      }

      const { code, data } = await apiContentEdit(params);
      if (code === 0) {
        this.$message.success("分享成功");
        this.shareDialogVisible = false;
        this.$router.push(`/${this.alias}/${data.id}.html`);
      }
    },
    showShareBtnTippy() {
      this.shareTippyInstance = tippy(this.$refs.shareBtn, {
        content: "欧爆了！快快分享！",
        placement: "top",
        arrow: true,
        theme: "__ck-share-btn-tippy__",
        offset: [0, 10],
        showOnCreate: true,
        trigger: "manual"
      });
    },
    /**
     * 在未登录时抽到五星后分享，需要登录，由于登录后刷新页面，所以将分享接口的参数暂存，页面mounted后检查并发送
     */
    async fetchSessionShareParams() {
      const json = sessionStorage.getItem("loginAfterShareParams");
      if (!json) return;
      const params = JSON.parse(json);
      const { code, data } = await apiContentEdit(params);
      if (code === 0) {
        sessionStorage.removeItem("loginAfterShareParams");
        this.$message.success("分享成功");
        this.$router.push(`/${this.alias}/${data.id}.html`);
      }
    }
  }
};
</script>
<style>
/* “分享至社区”按钮的起泡提示主题 */
.tippy-box[data-theme~="__ck-share-btn-tippy__"] {
  background-color: #274c81;
  color: #b7a35f;
  border-radius: 50px;
}
.tippy-box[data-theme~="__ck-share-btn-tippy__"] .tippy-content {
  padding: 4px 10px;
}
.tippy-box[data-theme~="__ck-share-btn-tippy__"] .tippy-arrow {
  color: #274c81;
}
</style>
<style lang="less" scoped>
.quilt-card {
  min-height: 100vh;
  padding-top: 70px;
  .quilt-card-container {
    position: relative;
    width: 888px;
    /* height: calc(100vh - 80px); */
    //height: 492px;
    margin: auto;
    border: 6px solid rgb(184, 187, 194);
    border-radius: 12px;
    overflow: hidden;
    background-color: #fff;
    .video-box {
      position: absolute;
      height: 480px;
      width: 100%;
      z-index: -1;
      video {
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
      }
      .mask {
        position: absolute;
        background-color: #fff;
        top: 0;
        right: 40px;
        width: 60px;
        height: 60px;
        z-index: 1;
      }
    }
    .card-box {
      position: relative;
      height: 480px;
      overflow: hidden;
      .back {
        position: absolute;
        left: 0;
        top: 22px;
        width: 112px;
        height: 38px;
        z-index: 4;
        cursor: pointer;
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
        border: 1px solid rgba(255, 255, 255, 0.6);
        border-left-width: 0;
        background: url("~@/assets/zs_imgs/ck-back.png") no-repeat;
        background-size: 11px 22px;
        background-position: right 10px center;
        background-color: rgba(0, 0, 0, 0.2);
      }
      .header {
        position: absolute;
        top: 22px;
        right: 43px;
        height: 38px;
        z-index: 4;
      }
      .bg-video {
        position: absolute;
        width: 100%;
        top: 50%;
        transform: translateY(-50%);
      }
      .footer {
        position: absolute;
        bottom: 18px;
        right: 40px;
        left: 170px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 13px;
        z-index: 2;
        .share-btn {
          height: 27px;
          line-height: 27px;
          text-align: center;
          border-radius: 40px;
          font-size: 14px;
          color: #6a6967;
          background: #dedad2 url("~@/assets/zs_imgs/ck-btn-share-bg.png") no-repeat;
          cursor: pointer;
          margin-right: auto;
          background-size: 15px;
          background-position: 12px center;
          padding: 0 10px 0 32px;
        }
        .quilt-btn {
          width: 107px;
          height: 43px;
          border-radius: 30px;
          text-align: center;
          background: url("~@/assets/zs_imgs/ck-btn-bg.png") no-repeat;
          background-size: 100% 100%;
          color: rgb(32, 80, 124);
          font-size: 14px;
          cursor: pointer;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          user-select: none;
          .price {
            width: 72px;
            height: 18px;
            line-height: 18px;
            text-align: right;
            background: #2e2e35 url("~@/assets/zs_imgs/ck-mutil-price-icon.png") no-repeat;
            background-position: 4px center;
            background-size: 20px 12px;
            border-radius: 20px;
            padding-right: 6px;
            color: #fff;
          }
        }
      }
    }
    .comment-box {
      /* */
    }
  }
}
.single-tip {
  display: flex;
  align-items: center;
  .icon {
    width: 12px;
    height: 11px;
    position: relative;
    bottom: 1px;
    right: 4px;
  }
  .txt {
  }
}
.mutil-tip {
  display: flex;
  align-items: center;
  .icon {
    width: 12px;
    height: 11px;
    position: relative;
    bottom: 1px;
    right: 4px;
  }
  .txt {
    white-space: nowrap;
  }
}
/deep/ .el-dialog__header {
  text-align: center;
  padding-bottom: 0;
  .el-dialog__title {
    font-weight: 600;
  }
}
/deep/ .el-dialog__body {
  padding: 20px 38px;
}
</style>
<style lang="less">
.__ck-mutil-tip-class__ {
  padding: 6px 12px !important;
  border-radius: 100px !important;
  transform: translateY(4px) !important;
}
.__ck-mutil-tip-star5-class__ {
  background: linear-gradient(
    90deg,
    rgb(231, 99, 212),
    rgb(134, 137, 242) 20.018%,
    rgb(92, 182, 229) 35.517%,
    rgb(86, 213, 206) 52.287%,
    rgb(92, 222, 143) 72.359%,
    rgb(253, 226, 85) 100%
  ) !important;
  border: 1px solid rgba(255, 255, 255, 0.5) !important;
  background-clip: border-box !important;
  .popper__arrow {
    bottom: -5px !important;
    border: none !important;
    transform: rotate(45deg);
    &::after {
      width: 6px !important;
      height: 6px !important;
      border: 1px solid #acecdb !important;
      border-width: 0 1px 1px 0 !important;
      background-color: #57d1d1 !important;
    }
  }
}
.__ck-mutil-tip-star4-class__ {
  background-color: #8c42ac !important;
  border: 1px solid #e85feb !important;
  .popper__arrow {
    bottom: -5px !important;
    border: none !important;
    transform: rotate(45deg);
    &::after {
      width: 6px !important;
      height: 6px !important;
      border: 1px solid #e85feb !important;
      border-width: 0 1px 1px 0 !important;
      background-color: #8c42ac !important;
    }
  }
}
.__ck-single-tip-hide-class__ {
  opacity: 0 !important;
}
</style>
